import { createSelector } from '../../../selectors'

import { constant } from './constant'

const getTargets = () => createSelector<NodeListOf<HTMLInputElement>>({ selector: constant.selector.target }, true)

export const selectors = {
	getTargets,
}
